import React from 'react'
import {ProductLink} from '../../../common/router_links/ProductLink'
import {Rental} from '../../../common/types/rental'
import {exhaustSwitchCase} from '../../../common/utils/exhaustSwitchCase'
import {SortablePaginatedTable} from '../../../webui/table/sortable-paginated-table/SortablePaginatedTable'
import {TableHeadCell} from '../../../webui/table/sortable-paginated-table/TableHeadCell'
import {Comparator, descendingComparator, getComparator} from '../../../webui/table/sortable-paginated-table/utils'
import {Typography} from '../../../webui/Typography'
import {generateProductsTimeUsedData, ProductsTimeBeingUsedData} from './generateProductsTimeUsedData'

interface Props {
  rentals: Rental[]
}

const createTableHeadCells = (): TableHeadCell<ProductsTimeBeingUsedData>[] => [
  {
    id: 'id',
    label: 'Product',
    render: (row) => <ProductLink product={row.product} />,
  },
  {
    id: 'rentalCount',
    label: '#Rentals',
    render: (row) => row.rentalCount,
  },
  {
    id: 'medianTime',
    label: 'Median time',
    render: (row) => row.medianTime,
  },
  {
    id: 'meanTime',
    label: 'Mean time',
    render: (row) => row.meanTime,
  },
]

const comparator: Comparator<ProductsTimeBeingUsedData> = (order, orderBy) => {
  switch (orderBy) {
    case 'id':
      return order === 'desc'
        ? (a, b) => descendingComparator(a.product.name, b.product.name)
        : (a, b) => -descendingComparator(a.product.name, b.product.name)
    case 'product':
    case 'meanTime':
    case 'medianTime':
    case 'rentalCount':
      break
    default:
      return exhaustSwitchCase(orderBy)
  }
  return getComparator(order, orderBy)
}

export const ProductsUseTimeTable: React.FC<Props> = ({rentals}) => {
  const rows = generateProductsTimeUsedData(rentals)

  if (rows.length <= 0) {
    return <Typography>{'There were no rentals with more than 1 minute during this period'}</Typography>
  }

  return (
    <SortablePaginatedTable
      getComparator={comparator}
      subTitle={`Latest ${rentals.length} rentals. Only rentals with a duration between 1 and 360 minutes are included.`}
      searchEnabled={false}
      title={'Mean time products are used'}
      initialRowsPerPage={rows.length}
      initialOrderByKey={'meanTime'}
      initialOrder={'desc'}
      tableHeadCells={createTableHeadCells()}
      rows={rows}
    />
  )
}
